import React from "react"
import UserI9Store from "../../../../stores/UserI9Store"

export default class Section1Review extends React.Component {
    constructor(props, context) {
        super(props, context)
        this.state = {
            i9: UserI9Store.getI9()
        }

        this.i9ChangeEvent = this.i9ChangeEvent.bind(this)
    }

    componentDidMount() {
        UserI9Store.on("change", this.i9ChangeEvent)
    }

    componentWillUnmount() {
        UserI9Store.removeListener("change", this.i9ChangeEvent, false)
    }

    i9ChangeEvent() {
        const _this = this
        this.setState({
            i9: UserI9Store.getI9()
        })
    }

    render() {
        if (this.state.i9) {
            return (
                <div className="Section1Review">
                    <embed
                        src={UserI9Store.getI9Pdf()}
                        width="730px"
                        height="500px"
                        style={{
                            border: "solid 1px #cccccc",
                            marginBottom: 10
                        }}
                    />
                    <div>
                        <b>
                            {this.state.i9.Employee_FirstName} {this.state.i9.Employee_LastName}
                        </b>{" "}
                        you attest, under penalty of purjury, that the above <b>section 1</b> is correct:
                    </div>
                </div>
            )
        }
    }
}
